import { render, staticRenderFns } from "./BaseCover2025.vue?vue&type=template&id=b01c8988&scoped=true"
import script from "./BaseCover2025.vue?vue&type=script&lang=js"
export * from "./BaseCover2025.vue?vue&type=script&lang=js"
import style0 from "./BaseCover2025.vue?vue&type=style&index=0&id=b01c8988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01c8988",
  null
  
)

export default component.exports